import { IComponentOptions, IController } from "angular";
import { GtmhubController } from "@gtmhub/core";
import { MetricTargetOperatorEnum } from "@webapp/okrs/metrics/models/metric.models";

interface CascadingMetricFormHeaderBindings {
  operator: MetricTargetOperatorEnum;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface CascadingMetricFormHeaderCtrl extends CascadingMetricFormHeaderBindings {}
class CascadingMetricFormHeaderCtrl extends GtmhubController implements IController {
  public operatorTypes = MetricTargetOperatorEnum;
}

export const CascadingMetricFormHeaderComponent: IComponentOptions = {
  bindings: {
    operator: "<",
  },
  controller: CascadingMetricFormHeaderCtrl,
  template: require("./cascading-metric-form-header.component.html"),
};
